import React from 'react';
import './UpdateFile.css';
import {MDBContainer, MDBRow, MDBCol, MDBCard, MDBCardBody, MDBCheckbox} from 'mdb-react-ui-kit';
import {Button} from 'react-bootstrap';
import {LazyLoadImage} from 'react-lazy-load-image-component';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faTrashAlt, faEye} from '@fortawesome/free-solid-svg-icons';

/**
 *  Update file view
 * @param {*} props props
 * @return {JSX}
 */
function UpdateFileView(props) {
  return (
    <div className="banktable-container">

      <MDBContainer fluid >
        <MDBRow className="d-flex justify-content-center align-items-center h-100 banktable-modal-content">
          <MDBCol col="12">
            <MDBCard className="bg-dark text-white my-2 mx-auto align-items-center"
              style={{borderRadius: '1rem', maxWidth: '800px'}}>
              <MDBCardBody className="mx-auto w-100 updatephoto-padding">
                <div style={{display: 'flex', justifyContent: 'space-between', marginTop: '20px'}}>
                  <button
                    type="button"
                    style={{fontSize: '28px', backgroundColor: '#212529', color: 'white'}}
                    onClick={() => props.handleDelete()}>
                    <FontAwesomeIcon icon={faTrashAlt}></FontAwesomeIcon>
                  </button>
                  <span
                    onClick={() => props.closeModal()}
                    style={{fontSize: '40px', cursor: 'pointer'}}>&times;</span>
                </div>
                <div className="app" style={{textAlign: 'center'}}>
                  <h4 className=" ">Modifier le fichier</h4>
                  <LazyLoadImage
                    style={{width: '90px', height: '90px'}}
                    src="/images/pdf.png"
                    alt="error"
                    className="chantierheure-photo"
                    placeholderSrc="/images/pdf.png"
                    effect="blur" />
                </div>
                <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center', marginTop: '10px'}}>
                  <button className="updatefile-btn updatefile-btnlook" onClick={() => window.open(props.pdfUrl, '_blank')}>
                    <FontAwesomeIcon icon={faEye} />
                  </button>
                </div>
                <div className="form-group">
                  <input
                    type="text"
                    name="name"
                    defaultValue={props.form.name}
                    onChange={props.handleChangeValue}
                    className="form-control"
                    placeholder="Nom du fichier" />
                </div>
                <div style={{marginTop: '28px'}}>
                  <input
                    className="form-control"
                    name="date"
                    type="date"
                    defaultValue={props.form.date}
                    onChange={props.handleChangeValue}
                    style={{
                      fontSize: '18px',
                      color: 'black',
                      fontWeight: '450',
                    }} />
                </div>
                <div style={{marginTop: '22px'}}>
                  <MDBCheckbox
                    name="extra1"
                    id="inlineCheckbox1114"
                    label="Extra possible"
                    checked={props.form.extra1}
                    onChange={props.handleChangeCheckbox}
                    inline />
                  {localStorage.getItem('admin') === '1' ?
          <React.Fragment>
            <MDBCheckbox
              name="extra2"
              id="inlineCheckbox2224"
              label="Extra valider"
              checked={props.form.extra2}
              onChange={props.handleChangeCheckbox}
              inline />
            <MDBCheckbox
              name="extra3"
              id="inlineCheckbox3334"
              label="Extra confirmer"
              checked={props.form.extra3}
              onChange={props.handleChangeCheckbox}
              inline />
          </React.Fragment> : '' }
                </div>
                {localStorage.getItem('admin') === '1' ?
                <div className="app" style={{textAlign: 'center', marginTop: '25px'}}>
                  <label className="labelFacture">PDF Privé ?</label>
                  <div className="toggle-switch" style={{marginBottom: '5px'}}>
                    <div>
                      <input
                        id="toggle2"
                        name="permission"
                        type="checkbox"
                        defaultChecked={props.form.permission}
                        onChange={props.handleChangeCheckbox} />
                      <label htmlFor="toggle2"></label>
                    </div>
                  </div>
                </div> : ''}

                <div className="form-group">
                  <textarea
                    type="text"
                    defaultValue={props.form.note}
                    name="note"
                    onChange={props.handleChangeValue}
                    className="form-control"
                    placeholder="Note" />
                </div>
                <Button
                  color="white"
                  size="lg"
                  style={{
                    color: 'white',
                    fontSize: 'calc(10px + 2vmin)',
                    backgroundColor: '#363E46',
                    border: 'none',
                    width: '100%',
                    marginTop: '10px',
                  }}
                  onClick={props.handleSubmit}>
            Enregistrer
                </Button>
              </MDBCardBody>
            </MDBCard>
          </MDBCol>
        </MDBRow>
      </MDBContainer>
    </div>
  );
}

export default UpdateFileView;
